import { useElement } from './core/element.js';
const name = 's-divider';
const props = {};
const style = `:host{display:flex;align-items:center;flex-shrink:0;margin:0 16px;gap:8px;font-size:.75rem;color:var(--s-color-outline, #70797c)}:host:before,:host:after{content:"";flex-grow:1;border-top:solid 1px var(--s-color-outline-variant, #bfc8cb)}:host(:empty){gap:0}`
const template = `<slot></slot>`
export class Divider extends useElement({ style, template, props }) {
}
Divider.define(name);
